import { useQuery } from '@tanstack/react-query';
import { useGql } from '@ah/design';
import { Header, PillTabs, PullToRefresh, type PillTab } from '@ah/design/mobile';
import { Sparkles } from 'lucide-react';
import { RECOMMENDED_STORIES_QUERY, type NewsStoryListItem } from '../shared/index.ts';
import { NewsStoryRow, ListSkeleton, ErrorRetry } from './_parts.tsx';

const TABS: PillTab[] = [
  { to: '/news',        label: 'For You', end: true },
  { to: '/news/latest', label: 'Latest' },
  { to: '/news/seen',   label: 'Read' },
  { to: '/news/saved',  label: 'Saved' },
];

export function NewsForYou() {
  const gql = useGql();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['news', 'for-you'],
    queryFn: async () => {
      const res = await gql.request<{ recommendedStories: NewsStoryListItem[] }>(RECOMMENDED_STORIES_QUERY);
      return res.recommendedStories;
    },
  });

  return (
    <div className="fixed inset-0 flex flex-col bg-background">
      <Header title="News" />
      <PillTabs tabs={TABS} />
      <PullToRefresh className="flex-1 px-3 py-3" onRefresh={() => refetch()}>
        {isLoading ? (
          <ListSkeleton variant="story" />
        ) : error ? (
          <ErrorRetry label="Could not load recommendations." onRetry={() => refetch()} />
        ) : !data || data.length === 0 ? (
          <div className="text-center py-16 text-muted-foreground">
            <Sparkles size={32} className="mx-auto mb-2 opacity-50" />
            <p className="text-sm">Personalised recommendations are building up — check back soon.</p>
          </div>
        ) : (
          <div className="space-y-3">
            {data.map((s) => <NewsStoryRow key={s.id} story={s} />)}
          </div>
        )}
      </PullToRefresh>
    </div>
  );
}
